import { contato, linkWhatsApp } from '../data/conteudo';
import { IconeEmail, IconeInstagram, IconeWhatsApp } from './Icones';
import mandala from '../images/mandala.png';
import styles from './Contato.module.css';

const Contato = () => (
  <section id="contato" className={styles.contato} aria-labelledby="titulo-contato">
    <img className={styles.mandala} src={mandala} alt="" aria-hidden="true" />
    <div className={`container ${styles.grade}`}>
      <div>
        <h2 id="titulo-contato">Vamos conversar?</h2>
        <p className={styles.texto}>
          Para informações, valores e agendamento, fale comigo pelo WhatsApp ou por e-mail. Respondo
          o quanto antes.
        </p>
      </div>

      <div className={styles.canais}>
        <a className={styles.canal} href={linkWhatsApp} target="_blank" rel="noopener noreferrer">
          <IconeWhatsApp />
          <span>
            <small>WhatsApp</small>
            {contato.telefoneExibicao}
          </span>
        </a>
        <a className={styles.canal} href={`mailto:${contato.email}`}>
          <IconeEmail />
          <span>
            <small>E-mail</small>
            {contato.email}
          </span>
        </a>
        <a
          className={styles.canal}
          href={`https://www.instagram.com/${contato.instagram}/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <IconeInstagram />
          <span>
            <small>Instagram</small>
            @{contato.instagram}
          </span>
        </a>
      </div>
    </div>
  </section>
);

export default Contato;
